<template>
  <generic-modal
    size="small"
    :title="$t('user')"
    icon="user"
    image="/images/icons/user_avatar.png"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finish"
    :show_ok="show_ok"
    :show_cancel="show_cancel"
    :footer_buttons="footer_buttons"
    ref="modal"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="ui two item pointing secondary menu">
          <a class="active item" data-tab="general">
            <i class="id badge icon"></i>
            {{ $t("general") }}
          </a>
          <a class="item" data-tab="suscriptions" v-if="user_.user_id">
            <i class="users icon"></i>
            {{ $t("role suscriptions") }}
          </a>
        </div>
        <div class="ui active tab basic segment" data-tab="general">
          <div
            class="two fields"
            v-bind:class="{ disabled: user && user.status_code == 'D' }"
          >
            <div class="field">
              <label for>{{ $t("username") }}</label>
              <div class="ui left icon input">
                <input type="text" name="username" v-model="user_.username" />
                <i class="user icon"></i>
              </div>
            </div>
            <div class="field">
              <label for>{{ $t("name") }}</label>
              <div class="ui left icon input">
                <input type="text" name="name" v-model="user_.name" />
                <i class="user icon"></i>
              </div>
            </div>
          </div>
          <div
            class="two fields"
            v-bind:class="{ disabled: user && user.status_code == 'D' }"
          >
            <div class="field">
              <label for>{{ $t("password") }}</label>
              <div class="ui left icon input">
                <input
                  type="password"
                  name="password"
                  v-model="user_.password"
                />
                <i class="key icon"></i>
              </div>
            </div>
            <div class="field">
              <label for>{{ $t("status") }}</label>
              <div class="ui toggle checkbox">
                <input type="checkbox" name="status" v-model="user_.status" />
                <label>{{ $t("active") }}</label>
              </div>
            </div>
          </div>
          <div class="field">
            <label for>{{ $t("email") }}</label>
            <div class="ui left icon input">
              <input type="text" name="email" v-model="user_.email" />
              <i class="at icon"></i>
            </div>
          </div>
          <!-- </div> -->
        </div>
        <div
          class="ui tab basic segment"
          data-tab="suscriptions"
          v-if="user_.user_id"
        >
          <div class="ui form">
            <div
              class="field"
              v-bind:class="{ disabled: user && user.status_code == 'D' }"
            >
              <label for>{{ $t("role finder") }}</label>
              <div class="ui blue search" ref="role_search">
                <div class="ui icon input">
                  <input
                    class="prompt"
                    type="text"
                    :placeholder="$t('search roles')"
                  />
                  <i class="search icon"></i>
                </div>
                <div class="results"></div>
              </div>
            </div>
            <div
              class="field"
              v-bind:class="{ disabled: user && user.status_code == 'D' }"
            >
              <label for>{{ $t("suscribed roles") }}</label>
              <div class="ui very relaxed suscription list">
                <div
                  class="ui basic label"
                  v-for="(suscription, index) in user_.usr_role_suscriptions"
                  v-bind:key="suscription.encrypted_id"
                >
                  {{ suscription.usr_role.name }}
                  <i
                    class="red delete icon"
                    v-on:click="unsuscribe(suscription, index)"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui error message"></div>
      </div>
      <div class="ui error icon message" v-if="user && user.status_code == 'D'">
        <i class="dont icon"></i> {{ $t("deleted user") }}
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import sha1 from "js-sha1";

export default {
  name: "UserModal",
  components: {
    "generic-modal": GenericModal,
  },
  data() {
    return {
      processing: false,
      user_: {},
      show_ok: true,
      show_cancel: true,
      footer_buttons: [
        {
          icon: "trash",
          text: this.$t("delete"),
          click: this.remove,
          color: "red",
        },
      ],
    };
  },
  props: {
    user: Object,
  },
  mounted() {
    let vm = this;
    if (vm.user.user_id) {
      vm.processing = true;
      local_api(vm, "post", "/user/do-get", {
        u: vm.user.encrypted_id,
      })
        .then((response) => {
          response.status = response.status_code == "A";
          vm.user_ = response;

          if (vm.user_.status_code == "D") {
            vm.show_ok = false;
            vm.show_cancel = false;
          }
        })
        .catch((err) => {
          error_toast(err);
        })
        .finally(() => {
          this.processing = false;
        });
    } else this.user_ = {};
  },
  methods: {
    finish() {
      this.processing = true;
      let vm = this;
      return new Promise(function (resolve, reject) {
        local_api(vm, "post", "/user/do-save", {
          i: vm.user_.user_id,
          u: vm.user_.username,
          n: vm.user_.name,
          p: vm.user_.password ? sha1(vm.user_.password) : undefined,
          s: vm.user_.status ? "A" : "I",
          m: vm.user_.email,
        })
          .then((response) => {
            vm.$emit("succedded", response);
            vm.$emit("init");
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            vm.processing = false;
          });
      });
    },
    unsuscribe(suscription, index) {
      let vm = this;
      this.$alertify.confirm(
        "are you sure to unsuscribe user?",
        function () {
          local_api(vm, "post", "/user_role_suscription/do-unsuscribe", {
            s: suscription.encrypted_id,
          })
            .then((response) => {
              console.log(response);
              vm.user_.usr_role_suscriptions.splice(index, 1);
            })
            .catch((err) => {
              window.jQuery(vm.$refs.form).form("add errors", [err]);
            })
            .finally(() => {
              vm.processing = false;
            });
        },
        function () {},
      );
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    remove() {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove user?"),
        function () {
          local_api(vm, "post", "/user/do-delete", {
            i: vm.user.encrypted_id,
          })
            .then(() => {
              window.jQuery(vm.$refs.modal).modal("hide");
              vm.$emit("destroy");
              vm.$emit("init");
              vm.$destroy();
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
  watch: {
    "user_.status": function () {
      let status = this.user_.status;
      if (status == false) {
        let username = this.user_.username;
        let nameIsInactive = username.startsWith("_INACTIVE_");
        if (!nameIsInactive)
          this.user_.username = "_INACTIVE_" + this.user_.username;
      } else {
        this.user_.username = this.user_.username.replace("_INACTIVE_", "");
      }
    },
  },
  updated() {
    let vm = this;
    this.$nextTick(function () {
      window.jQuery(vm.$el).find(".ui.menu .item").tab();

      window.jQuery(this.$refs.role_search).search({
        apiSettings: {
          action: "search role",
          beforeXHR: function (xhr) {
            let token = vm.$session.get("token");
            if (token) {
              xhr.setRequestHeader("x-access-token", token);
            }
            return xhr;
          },
          onResponse: function (response) {
            if (!response.success) error_toast(response.error);
            else {
              var _response = {
                results: [],
              };
              response.data.map((r) => {
                _response.results.push({
                  title: r.name,
                  description: r.description,
                  role: r,
                });
              });
              return _response;
            }
          },
        },
        onSelect(result) {
          local_api(vm, "post", "/user_role_suscription/do-suscribe", {
            u: vm.user.user_id,
            r: result.role.role_id,
          })
            .then((response) => {
              vm.user_.usr_role_suscriptions.push(response);
            })
            .catch((err) => {
              error_toast(err);
            })
            .finally(() => {
              vm.processing = false;
            });
        },
      });
    });
  },
};
</script>

<style scoped>
.ui.suscription.list .label {
  margin: 5px 5px 0 0;
}

.content .description {
  width: 100% !important;
}
</style>
